import { useEffect, useState } from "react";
import api, { formatApiError } from "../../lib/api";
import { toast } from "sonner";
import { UserPlus } from "lucide-react";

export default function CustomersTab() {
    const [customers, setCustomers] = useState([]);
    const [form, setForm] = useState({ name: "", phone: "", notes: "" });
    const [loading, setLoading] = useState(false);

    const load = async () => {
        const { data } = await api.get("/customers");
        setCustomers(data);
    };

    useEffect(() => { load(); }, []);

    const upd = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

    const add = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await api.post("/customers", form);
            setForm({ name: "", phone: "", notes: "" });
            toast.success("Customer added");
            await load();
        } catch (err) {
            toast.error(formatApiError(err?.response?.data?.detail) || err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="space-y-6" data-testid="customers-page">
            <div>
                <h2 className="font-display text-3xl font-extrabold text-onego-navy">Customers</h2>
                <p className="text-slate-600">Track repeat buyers and their purchase history.</p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                <form onSubmit={add} className="og-card p-7" data-testid="customer-form">
                    <h3 className="font-display text-xl font-bold text-onego-navy flex items-center gap-2"><UserPlus size={18} /> Add customer</h3>
                    <div className="mt-4 space-y-3">
                        <input className="og-input" required placeholder="Name" value={form.name} onChange={upd("name")} data-testid="customer-name-input" />
                        <input className="og-input" required placeholder="Phone" value={form.phone} onChange={upd("phone")} data-testid="customer-phone-input" />
                        <textarea className="og-input" rows={3} placeholder="Notes" value={form.notes} onChange={upd("notes")} data-testid="customer-notes-input" />
                        <button type="submit" disabled={loading} className="og-btn-gradient w-full disabled:opacity-60" data-testid="customer-submit-btn">
                            {loading ? "Saving\u2026" : "Add customer"}
                        </button>
                    </div>
                </form>

                <div className="lg:col-span-2 og-card p-7">
                    <h3 className="font-display text-xl font-bold text-onego-navy">All customers</h3>
                    <div className="mt-4 divide-y divide-slate-100">
                        {customers.length === 0 && <p className="py-6 text-sm text-slate-500">No customers yet.</p>}
                        {customers.map((c) => (
                            <div key={c.id} className="py-4 flex items-center justify-between gap-4" data-testid={`customer-row-${c.id}`}>
                                <div>
                                    <p className="font-bold text-onego-navy">{c.name}</p>
                                    <p className="text-xs text-slate-500">{c.phone}</p>
                                    {c.notes && <p className="text-xs text-slate-500 mt-1 italic">{c.notes}</p>}
                                </div>
                                <p className="text-xs text-slate-400">{new Date(c.created_at).toLocaleDateString()}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
